import {useState, useCallback} from 'react'
import {useSnackbar} from 'notistack'
import {getGeneric} from '../../common/constants'

export function usePaceShipmentCounts() {
  const [isLoadingSummary, setIsLoadingSummary] = useState(false)
  const [isLoadingMerchants, setIsLoadingMerchants] = useState(false)
  const [summary, setSummary] = useState(null)
  const [merchantData, setMerchantData] = useState(null)
  const {enqueueSnackbar} = useSnackbar()

  const loadSummary = useCallback(
    async ({fromDate, toDate, merchantId}) => {
      setIsLoadingSummary(true)
      setSummary(null)
      try {
        const params = {fromDate, toDate}
        if (merchantId) params.merchantId = merchantId
        const res = await getGeneric('dynamiccourier/pace/admin/analytics/summary', params)
        setSummary(res.data?.result || res.data?.data || res.data)
      } catch (err) {
        enqueueSnackbar('Failed to load PACE summary', {variant: 'error'})
      } finally {
        setIsLoadingSummary(false)
      }
    },
    [enqueueSnackbar]
  )

  const loadMerchants = useCallback(
    async ({fromDate, toDate, merchantId}) => {
      setIsLoadingMerchants(true)
      setMerchantData(null)
      try {
        const params = {fromDate, toDate}
        if (merchantId) params.merchantId = merchantId
        const res = await getGeneric('dynamiccourier/pace/admin/analytics/merchants', params)
        setMerchantData(res.data?.result || res.data?.data || res.data)
      } catch (err) {
        enqueueSnackbar('Failed to load PACE merchant data', {variant: 'error'})
      } finally {
        setIsLoadingMerchants(false)
      }
    },
    [enqueueSnackbar]
  )

  const loadAll = useCallback(
    async (params) => {
      await Promise.all([loadSummary(params), loadMerchants(params)])
    },
    [loadSummary, loadMerchants]
  )

  return {
    isLoadingSummary,
    isLoadingMerchants,
    summary,
    merchantData,
    loadAll,
  }
}
